import * as actionTypes from 'src/old/actions';
import { orderBy } from 'lodash';
import { byPendingReview, updateRequests } from 'src/old/reducers/dataChangeRequests/helpers';
import { type DataChangeRequestsAction } from 'src/old/reducers/dataChangeRequests/types';

const initialState = { employeesRequestedDataChange: { data: [], meta: {} } };

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
const dataChangeRequestsReducer = (state = initialState, action: DataChangeRequestsAction) => {
  switch (action.type) {
    case actionTypes.FETCH_DATA_CHANGE_REQUESTS: {
      return {
        ...state,
        employeesRequestedDataChange: {
          ...action.response,
          data: orderBy(
            action.response.data,
            ['dataConfirmationStatus', 'dataConfirmation.requestedAt'],
            ['desc', 'asc']
          )
        }
      };
    }

    case actionTypes.PUT_DATA_CHANGE_REQUEST: {
      const withUpdatedRequest = updateRequests(state.employeesRequestedDataChange.data, action.response);

      return {
        ...state,
        employeesRequestedDataChange: {
          ...state.employeesRequestedDataChange,
          data: withUpdatedRequest,
          meta: {
            ...state.employeesRequestedDataChange.meta,
            totalCompanyPendingRequests: withUpdatedRequest.filter(byPendingReview)?.length
          }
        }
      };
    }

    default: {
      return state;
    }
  }
};

export default dataChangeRequestsReducer;
